// Please keep the enum sorted alphabetically
export enum FeatureFlags {
  ACCESS_RYST_INCENTIVES = 'ACCESS_RYST_INCENTIVES',
  ACTIVITY_LOG_TABLE_VERSION_3 = 'ACTIVITY_LOG_TABLE_VERSION_3',
  AGILYSYS_DOD_CENTRIC = 'AGILYSYS_DOD_CENTRIC',
  ALLOW_SCHEDULE_WITHOUT_MOBILE_CDL_21573 = 'ALLOW-SCHEDULE-WITHOUT-MOBILE-CDL-21573',
  ANNOUNCEMENT_BUTTON_LINK = 'ANNOUNCEMENT_BUTTON_LINK',
  ARCHIVED_GLOBAL_BRANDS = 'ARCHIVED_GLOBAL_BRANDS',
  AUTO_PUSH_PHASE_2 = 'AUTO_PUSH_PHASE_2',
  AUTO_PUSH_TOGGLE = 'CDL-22813-auto-push-toggle',
  BRAND_JDE_CATEGORY = 'Brand-JDE-Category',
  BRAND_ALT_LANGUAGES = 'BRAND_ALT_LANGUAGES',
  BUSINESS_UNIT_COPY_ID = 'BUSINESS_UNIT_COPY_ID',
  BUSINESS_UNIT_EDGE_DELETION = 'BUSINESS_UNIT_EDGE_DELETION',
  CANADA_REFUNDS_ENABLED = 'CDL-10248-allow-canada-refunds',
  CATALOG_BACKUP_VERSION_EXPORT = 'catalog-backup-version-export',
  CDL_28980_PI_MITIGATION = 'CDL-28980-PI-Mitigation',
  DISPLAY_INSTITUTION_LIST = 'DISPLAY_INSTITUTION_LIST',
  CENTRIC_BROWSE_DISCOVER = 'centric-browse-discover',
  CENTRIC_HOME_OVERVIEW_SITE = 'centric-home-overview-site',
  CENTRIC_UI_LOCALIZATION = 'centric-ui-localization',
  CENTRIC_MOBILE_ORDER_BROWSING = 'centric-mobile-order-browsing',
  CENTRIC_MOBILE_PRIMARY_NAVIGATION = 'centric-mobile-primary-navigation',
  CENTRIC_PASSWORD_RESET = 'CENTRIC_PASSWORD_RESET',
  CENTRIC_STATION_FILTER = 'centric-station-filter',
  CENTRIC_USER_MANAGEMENT = 'centric-user-management',
  CENTRIC_HUB_VISIBLE = 'CENTRIC_HUB_VISIBLE',
  CPG_ITEM_UPLOAD = 'CDL-18946-CPG-upload',
  CREATE_MODIFY_STATION_DISCOUNTS = 'CREATE_MODIFY_STATION_DISCOUNTS',
  DISCOUNT_THIRD_PARTY_CHANNELS_NEXTEP = 'DISCOUNT_THIRD_PARTY_CHANNELS_NEXTEP',
  DISCOUNT_THIRD_PARTY_CHANNELS_AGILYSYS = 'DISCOUNT_THIRD_PARTY_CHANNELS_AGILYSYS',
  DISCOUNTS_REPORTING = 'Discounts_Reporting',
  DISPLAY_REPORTING_DIAGNOSTICS = 'DISPLAY_DATA_DIAGNOSTICS',
  EXTENDED_NUTRITION_DISPLAY = 'extended_nutrition_display',
  FORCE_ADMIN_SSO_LOGIN = 'CSS2-117-centric-force-admin-sso',
  GENERATIVE_AI = 'generative-ai',
  GENERATIVE_AI_V2 = 'GENERATIVE_AI_V2',
  GLOBAL_MENU_MANAGEMENT = 'global_menu_management',
  GLOBAL_ACTIVITY_LOG = 'global-activity-log',
  GRUB_HUB_CENTRIC_INTEGRATION = 'GRUB_HUB_CENTRIC_INTEGRATION',
  HIDE_BOOST_TOGGLE = 'HIDE_BOOST_TOGGLE',
  HOMEPAGE_RECOMMENDATIONS = 'HOMEPAGE_RECOMMENDATIONS',
  INTEGRATION_AGNOSTIC_SITE = 'INTEGRATION_AGNOSTIC_SITE',
  ITEM_AND_MODIFIER_BULK_DELETE = 'CDL-18713-Item-Modifier-Bulk-Delete',
  ITEM_DISCOUNTS = 'ITEM_DISCOUNTS',
  ITEM_MODIFIER_JDE = 'ITEM_MODIFIER_JDE',
  JWO_MENU_INTEGRATION = 'JWO-Menu-Integration',
  JWO_PICKUP_FLAG = 'JWO_Pickup_Flag',
  JWO_MINIMUM_BALANCE = 'JWO_MINIMUM_BALANCE',
  JWO_SITE_CONFIG = 'JWO_SITE_CONFIG',
  LABS = 'centric-labs',
  LUNA = 'luna',
  LUNA_CHAT = 'luna-chat',
  LUNA_MENUWORKS = 'luna-menuworks',
  MANAGE_ANNOUNCEMENTS = 'MANAGE_ANNOUNCEMENTS',
  MANAGE_MARKETING = 'MANAGE-MARKETING',
  MANAGE_SITE_DELETION = 'MANAGE_SITE_DELETION',
  MANAGE_BUSINESS_UNIT_DELETION = 'MANAGE_BUSINESS_UNIT_DELETION',
  MENU_LABELS = 'menu_labels',
  MENU_STATUS_AGILYSYS = 'MENU-STATUS-AGILYSYS',
  MENU_STATUS_AGILYSYS_DOD = 'MENU-STATUS-AGILYSYS-DOD',
  MENU_STATUS_GRUB_HUB = 'MENU_STATUS_GRUBHUB',
  MENU_STATUS_TRANSACT = 'MENU-STATUS-TRANSACT',
  MENU_STATUS_STARSHIP = 'MENU_STATUS_STARSHIP',
  MENU_STATUS_MASHGIN = 'MENU-STATUS-MASHGIN',
  MENU_STATUS_TIME2EAT = 'MENU-STATUS-TIME2EAT',
  MENU_V2_MENUWORKS_ICONS = 'MENU_V2_MENUWORKS_ICONS',
  MENU_VISIBILITY_SETTINGS = 'MENU_VISIBILITY_SETTINGS',
  MENUWORKS_PRODUCTS_BROWSER = 'MENUWORKS_PRODUCTS_BROWSER',
  MENUWORKS_V2 = 'CDL-19289-Menuworks-v2',
  MODIFIER_CREATE_MENUWORKS = 'MODIFIER-CREATE-MENUWORKS',
  MRN_POPUPS_REMOVAL = 'MRN_POPUPS_REMOVAL',
  NEW_STATION_HOURS_DISPLAY = 'NEW_STATION_HOURS_DISPLAY',
  NEXTEP_STATION_ALLOW_DISABLE_MENU = 'Nextep-Station-Allow-Disable-Menu',
  NEXTEP_ORDER_STREAMING = 'NEXTEP_ORDER_STREAMING',
  OPTIMIZED_USER_LOADING = 'OPTIMIZED_USER_LOADING',
  ORDER_SEARCH_BAR = 'ORDER_SEARCH_BAR',
  OVERVIEW_SNAPSHOT = 'overview-snapshot',
  REVENUE_OPTIMIZED_MENUS = 'revenue-optimized-menus',
  ROM_RESET_BRAND_FOR_DEMO = 'rom-reset-brand-for-demo',
  SCANNER = 'CDL-18134-scanner',
  SCHEDULED_DISCOUNTS = 'SCHEDULED_DISCOUNTS',
  SHOW_REVIEWS = 'SHOW-REVIEWS',
  SITE_ADDRESS_LOOKUP_WITH_EDGE_SERVICE = 'SITE_ADDRESS_LOOKUP_WITH_EDGE_SERVICE',
  SITE_STATUS_ARCHIVED = 'SITE_STATUS_ARCHIVED',
  SITE_VISIBILITY_UX = 'SITE_VISIBILITY_UX',
  STARSHIP_CENTRIC_INTEGRATION = 'STARSHIP_CENTRIC_INTEGRATION',
  STOCK_MODULE = 'stock-module',
  TERMINAL_SALES = 'CDL-18787-terminal-sales-report',
  THIRD_PARTY_APPS_REQUIRE_THRIVE_BOOST = 'THIRD_PARTY_APPS_REQUIRE_THRIVE_BOOST',
  TIME2EAT_TOGGLE = 'TIME2EAT_TOGGLE',
  TRAKER_IN_CENTRIC = 'traker-in-centric',
  TRANSACT_CENTRIC_INTEGRATION = 'TRANSACT_CENTRIC_INTEGRATION',
  TYPE_OF_KDS_SYNC = 'TYPE_OF_KDS_SYNC',
  RYST_CENTRIC_INTEGRATION = 'RYST_CENTRIC_INTEGRATION',
  UPDATED_REFUND_WORKFLOW = 'UPDATED_REFUND_WORKFLOW',
  USE_BRAND_PREPUBLISH_VALIDATION = 'CDL-24341-USE_BRAND_PREPUBLISH_VALIDATION',
  VIEW_SALES_READINGS = 'VIEW_SALES_READINGS',
  VOUCHERIFY_REPLACEMENT = 'VOUCHERIFY_REPLACEMENT',
  V4_MENU = 'CDL-20309-V4-Menu-Composite',
  VERTEX_ENABLED = 'VERTEX_ENABLED',
  ZENDESK_HIDE_ON_LOGIN_PAGE = 'ZENDESK_HIDE_ON_LOGIN_PAGE',
}

export enum AP3FeatureFlags {
  USER_MANAGEMENT = 'AP3-USER-MANAGEMENT',
}
